import { createIcon } from '@chakra-ui/icons';

export const PhoneLocked = createIcon({
  displayName: 'PhoneLocked',
  viewBox: '0 0 32 33',
  path: [
    <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.75 7.34766H14.25C14.1119 7.34766 14 7.23573 14 7.09766C14 6.95959 14.1119 6.84766 14.25 6.84766H17.75C17.8881 6.84766 18 6.95959 18 7.09766C18 7.23573 17.8881 7.34766 17.75 7.34766Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M13.2036 30.8477H10C8.34315 30.8477 7 29.5046 7 27.8477V5.84766C7 4.19081 8.34315 2.84766 10 2.84766H22C23.6569 2.84766 25 4.19081 25 5.84766V14.1333"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M27.5 23.8477H18.5C17.6716 23.8477 17 24.5193 17 25.3477V29.3477C17 30.1761 17.6716 30.8477 18.5 30.8477H27.5C28.3284 30.8477 29 30.1761 29 29.3477V25.3477C29 24.5193 28.3284 23.8477 27.5 23.8477Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M20 23.8477V20.8477C20 19.1908 21.3431 17.8477 23 17.8477C24.6569 17.8477 26 19.1908 26 20.8477V23.8477"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
